exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer.footer-container {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: absolute;\n  background: transparent;\n  height: 30px;\n  padding: 8px 26px;\n  font-size: 12px;\n  justify-content: flex-end; }\n  footer.footer-container .footer-company {\n    padding: 0 2px; }\n  footer.footer-container hr.footer-divider-vertical {\n    margin: 0 5px;\n    background: #000;\n    width: 1px; }\n", ""]);

// exports
